import { SupportedDataFormats } from './docs/SupportedDataFormats';
import { LipidColumn } from './docs/LipidColumn';
import { AssayColumns } from './docs/AssayColumns';
import { OptimizationParameters } from './docs/OptimizationParameters';
import { Graphs } from './docs/Graphs';
import { Model } from './docs/Model';


export const DocumentationPage = () => (
  <div className="doc-container">
    <h2>Documentation</h2>
    <Model />
    <Graphs />
    <OptimizationParameters />
    <SupportedDataFormats />
    <LipidColumn />
    <AssayColumns />
  </div>
)
